import { Component, OnInit } from '@angular/core';
import { getDataProjectLinkQueryParams } from 'src/app/services/data-project/models/data-project.model';
import { NavbarService } from 'src/app/services/navbar/navbar.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
    readonly linkQueryParams = getDataProjectLinkQueryParams;

    constructor(public service: NavbarService) {}

    ngOnInit(): void {}
}
